import { Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SendRoundedIcon from '@material-ui/icons/SendRounded';
import TextField from '@material-ui/core/TextField';

import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import DOMPurify from 'dompurify';
import marked from 'marked';

function LiveStreamChat(props)
{
	const [ errorObj, setErrorObj ] = useState({});
	const [ message, setMessage ] = useState('');
	const [ chatMessages, setChatMessages ] = useState(props?.messages);
	const handleClose = () =>
	{
		props?.handleCloseChat(!props.openChat);
	};

	const sendMessage = async (e) =>
	{
		e.preventDefault();

		const val = message;

		if (val && val.trim() !== '')
		{
			const body = {
				userId    : props?.broadcastUserDetails?.userId,
				meetingId : props?.broadcastUserDetails?.meetingId,
				message   : val,
				sendTime  : new Date().valueOf(),
				sender    : 'Guest',
				userName  : props?.broadcastUserDetails?.name,
				type	  : 'message'
			};

			props?.socket.emit('send-message', body);

			await axios.post(`${import.meta.env.VITE_InVcMainchatAPI}/createChat`, body)
				.then((res) =>
				{
				})
				.catch((err) =>
				{
					console.log('chat err', err);
				});

			setMessage('');

		}
	};

	useEffect(() =>
	{

		props?.socket.on('get-message', (data) =>
		{
			setChatMessages((prevState) => [ ...prevState, data ]);
			// setChat([...chat, data])
		});
	}, [ props?.socket ]);

	const handleMessage = (e) =>
	{
		setMessage(e.target.value);
	};

	return (
		<div className={props?.openChat ? 'flexCol liveStreamChat' : 'flexCol liveStreamChatnone'} >
			<div className='flexRow cHead'>
				<span className='pdngSM' >Chat</span>
				<Button size='small' color='default' onClick={handleClose} >
					<CloseIcon fontSize='small' />
				</Button>
			</div>
			<div className='flexMinWidthCol cBody'>
				{chatMessages?.length > 0 && chatMessages?.map((msg, index) =>
				{
					const date = new Date(msg.sendTime);

					const hours = date.getHours();

					const minutes = `0${ date.getMinutes()}`;
					// var seconds = "0" + date.getSeconds();

					const formattedTime = `${hours }:${ minutes.substr(-2)}`;

					return (
						<>
							{ ((msg.userId === props.broadcastUserDetails.userId && msg.sender === 'Guest') || (msg.sender === 'Host')) &&
							(msg.userId === props.broadcastUserDetails.userId && msg.sender === 'Guest') ?
								<div className='flexCol msgPdng meMsg' key={index}>
									<small ><b>{msg.userName}</b> {formattedTime} </small>
									<div className='flexInlineCo lsMsg'>
										<span >{msg.message}</span>
									</div>
								</div>
								:
								<div className='flexCol msgPdng peerMsg'>
									<small ><b>{msg.userName}</b> {formattedTime} </small>
									<div className='flexInlineCo lsMsg'>
										<span >{msg.message}</span>
									</div>
								</div>

							}
						</>
					);

				})}
			</div>
			<div className='cFooter'>
				<form onSubmit={sendMessage} className='flexRow'>
					<TextField
						fullWidth
						margin='dense'
						size='small'
						// rowsMax='4'
						// multiline
						variant='outlined'
						autoFocus
						type='text'
						value={message}
						onChange={handleMessage}
						helperText={errorObj.message ? errorObj.message : ''}
						FormHelperTextProps={{
							error    : errorObj.message ? true : false,
							required : true
						}}
					/>
					<Button type='submit' color='primary'>
						<SendRoundedIcon />
					</Button>
				</form>
			</div>
		</div>
	);
}

export default LiveStreamChat;